import type { FC } from 'react'

import clsx from 'clsx'
import { formatSize } from 'shared/files'
import { typo } from 'shared/styles'
import { StackIcon } from 'shared/ui'

import type { MessageFile } from '../../model/types'

import css from './FilePreview.module.css'

interface Props {
	file: MessageFile | null
	url: string
}

export const FilePreview: FC<Props> = ({ file, url }) => (
	<a
		className={css.file}
		download
		href={url}
		rel='noopener noreferrer'
		target='_blank'
	>
		<span className={css.name}>{file?.name}</span>
		{formatSize(file?.byte_size ?? 0)}

		<span className={clsx(typo.buttonSmB, css.hover)}>
			<StackIcon icon='download' stack='linkedin' />
			Download
		</span>
	</a>
)
